import React, { useState, useRef, useCallback } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { GetApp, ArrowDropDown } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(1),
    minWidth: 160,
    whiteSpace: "nowrap",
  },
}));

const SHAPEFILE_DOWNLOADS = [
  {
    id: "active_wells",
    label: "Active Barton Springs Wells",
    url: "https://bseacd-data.org/pubfiles/bseacd_wells_active.zip",
  },
];

const ShapefileDownloads = () => {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleToggle = useCallback(() => setOpen((p) => !p), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleItemClick = useCallback(() => setOpen(false), []);

  return (
    <>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        variant="contained"
        color="primary"
        startIcon={<GetApp />}
        endIcon={<ArrowDropDown />}
        className={classes.button}
        aria-haspopup="true"
        aria-controls={open ? "downloads-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
      >
        Download Shapefiles
      </Button>

      <Menu
        id="downloads-menu"
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        keepMounted
      >
        {SHAPEFILE_DOWNLOADS.map((d) => (
          <MenuItem
            key={d.id}
            component="a"
            href={d.url}
            onClick={handleItemClick}
            download
          >
            {d.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ShapefileDownloads;
